/**
* CLASS DataGridList
*
* Contiene el cuerpo de la tabla del datagrid
*
* @author Hector Morales <hector.morales@ikarosofttechnology.com>
*/

import React from 'react'
import DataGridRow from './DataGridRow'

class DataGridList extends React.Component {

  render() {
      return (
          <tbody>
              {
                  this.props.listado.map((listado,i) => {
                      return <DataGridRow key={ i }
                                               numberRow = {i}
                                               dataRow = {listado}  
                                               titulo={this.props.titulo}                                                                                   
                                               funcionClick={this.props.funcionClick} 
                                               colsData={this.props.colsData}
                                               apiField={this.props.apiField}
                                               apiRoute={this.props.apiRoute}
                                               formFields={this.props.formFields}
                                               mainContainer={this.props.mainContainer}
                                               parametro={this.props.parametro}
                                               colsHeaders={this.props.colsHeaders}
                                               automatica={this.props.automatica}
                                               enableRowClick={this.props.enableRowClick} 
                                               funcionEdit = {this.props.funcionEdit}
                                               tbarEdit = {this.props.tbarEdit}
                                               tbarItems = {this.props.tbarItems}
                                               funcionEditParams = {this.props.funcionEditParams} 
                                               funcionAfterUpdate = {this.props.funcionAfterUpdate}
                                               funcionBeforeDelete = {this.props.funcionBeforeDelete}
                                               enableBtnEdit={this.props.enableBtnEdit}
                                               permisoBtnUpdate = {this.props.permisoBtnUpdate}
                                               enableBtnDel={this.props.enableBtnDel}
                                               dataLog={this.props.dataLog}/>
                  })
              }
          </tbody>
      )
      
  }
}

export default DataGridList